export default __webpack_public_path__ + "static/personalization-abc9907919f84ddc817cc1e710ae5432.mp4";